import React, { useEffect } from "react";
import MaintenancePage from "../maintenance/MaintenancePage";

function ScoreQueryPage() {
  useEffect(() => {
    document.title = "成绩查询";
  }, []);
  return <MaintenancePage />;
}

export default ScoreQueryPage;
